import { HashRouter as Router, Switch, Route } from "react-router-dom";
import { Report } from "./Report/Report";
import { Quotation } from "./Quotation/Quotation";
import { Servicecard } from "./Servicecard/Servicecard";
import { Serviceorder } from "./ServiceOrder/Serviceorder";

const RouterPath = [
  {
    pathName: "report",
    Component: Report,
  },
  {
    pathName: "quotation",
    Component: Quotation,
  },
  {
    pathName: "servicecard",
    Component: Servicecard,
  },
  {
    pathName: "serviceorder",
    Component: Serviceorder,
  },
];

export const PrintDocumentRoute = () => {
  return (
    <Router>
      <Switch>
        {RouterPath.map((el) => ({
          ...el,
          pathName: `/printDocument/${el.pathName}`,
        })).map(({ pathName, Component }) => (
          <Route exact path={pathName} render={() => <Component />} />
        ))}
      </Switch>
    </Router>
  );
};
